/**
 * Captures a single frame from a video as a PNG data url.
 * Resolves with an empty string if a frame can't be captured, so callers never have to catch.
 *
 * @param {string} videoUrl - An object url or any url the browser can play
 * @return {Promise<string>}
 */
export const generateVideoThumbnail = (videoUrl) => {

  return new Promise((resolve) => {

    const video = document.createElement("video");

    let settled = false;

    const finish = (result) => {

      if (settled) return;

      settled = true;
      clearTimeout(timeout);
      video.removeAttribute("src");
      video.load();
      resolve(result);

    };

    // Some mobile browsers never fire the events below for unsupported codecs
    const timeout = setTimeout(() => finish(""), 8000);

    video.muted = true;
    video.playsInline = true;
    video.preload = "auto";
    video.setAttribute("playsinline", "");

    video.onerror = () => finish("");

    const capture = () => {

      try {

        const width  = video.videoWidth;
        const height = video.videoHeight;

        if (!width || !height) {
          finish("");
          return;
        }

        const canvas  = document.createElement("canvas");
        canvas.width  = Math.round(width / 3);
        canvas.height = Math.round(height / 3);

        canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);

        finish(canvas.toDataURL());

      } catch (error) {

        finish("");

      }

    };

    video.onloadedmetadata = () => {

      const duration = Number.isFinite(video.duration) ? video.duration : 0;
      const target   = Math.min(1, duration / 2);

      // Seeking to the current time won't fire "seeked"
      if (target === video.currentTime) {
        video.onloadeddata = capture;
        return;
      }

      video.onseeked = capture;
      video.currentTime = target;

    };

    video.src = videoUrl;

  });

};
